import {Component, ContentChild} from "@angular/core";
import {FUIButtonComponent} from "../button.component";
import {FUIIconComponent} from "../../../icons/icon/icon.component";

@Component({
    selector: "fui-outline-button",
    styleUrls: ["./outline-button.component.scss"],
    templateUrl: "./outline-button.component.html"
})
export class FUIOutlineButtonComponent extends FUIButtonComponent {
    @ContentChild(FUIIconComponent) public icon: FUIIconComponent;
}
